export const allDomains = [
  'activeden.net',
  'audiojungle.net',
  'themeforest.net',
  'videohive.net',
  'graphicriver.net',
  '3docean.net',
  'codecanyon.net',
  'photodune.net',
  'market.envato.com',
  'market.styleguide.envato.com',
  'elements.envato.com',
  'build.envatohostedservices.com',
  'author.envato.com'
]

// The order of exported sites determines the order of logotypes
// in the header.
export const siteNames = [
  'themeforest',
  'codecanyon',
  'videohive',
  'audiojungle',
  'graphicriver',
  'photodune',
  '3docean'
]



// WEBPACK FOOTER //
// ./common/constants/siteList.js